(function () {
	'use strict';

	// user selector template loaded via webpack
	var userSelectorTemplateUrl = require('../userSelectorDialog/userSelectorDialog.template');

	/**
	 * @ngdoc directive
	 * @name smb-app.directive:smbadminUserGroup
	 * @module smb-app
	 * @restrict E
	 * @description
	 *
	 * `smbadminUserGroup` displays a User Group to add/edit
	 *
	 * @usage
	 *
	 * <smbadmin-UserGroup UserGroup-id="1" />
	 *
	 * @element input
	 * @param {number=} UserGroupId The id of the User Group to display
	 */

	angular
		.module('smb-app')
		.directive('smbadminUserGroup',
		[
			UserGroupDirective
		])
		.controller('smbadminUserGroupController',
		[
			'$state',
			'$mdDialog',
			'sbToastService',
			'smbToolbarService',
			'smbUserGroupDataStore',
			'smbUsersDataStore',
			'pxAuthService',
			'pxProgressService',
			'gettextCatalog',
			UserGroupController
		]);

	var templateUrl = require('./userGroup.template');
	function UserGroupDirective() {
		return {
			restrict: 'E',
			controller: 'smbadminUserGroupController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: {
				deploymentId: '@',
				userGroupId: '@'
			},
			scope: {}
		};
	}

	function UserGroupController($state, $mdDialog, sbToastService, smbToolbarService, smbUserGroupDataStore, smbUsersDataStore, pxAuthService, pxProgressService, gettextCatalog) {
		var vm = this;

		var title = vm.userGroupId ? gettextCatalog.getString('Edit User Group') : gettextCatalog.getString('Create User Group');
		smbToolbarService.set(title, 'useradmin.home.usergroups');

		vm.deploymentId = pxAuthService.deploymentId;
		vm.loading = false;
		vm.doneLoading = doneLoading;
		vm.userGroupDS = smbUserGroupDataStore;
		vm.usersDS = smbUsersDataStore;
		vm.removeUser = removeUser;
		vm.addUsers = addUsers;
		vm.save = save;
		vm.systemName = null;
		vm.userExists = userExists;

		var currentUsers = null;

		(function initUserGroupController() {
			isLoading();

			vm.systemName = pxAuthService.systemName;
			vm.userGroupDS.getUserGroup(vm.userGroupId, vm.systemName)
				.then(function loadUserGroup(group) {
					currentUsers = group.Embedded.Users.map(function (usr) { return Object.assign({}, usr); });
				})
				.then(function loadUsers() {
					smbUsersDataStore.getUsers();
				})
				.finally(doneLoading);
		})();

		function userExists(usr) {
			if (!currentUsers) {
				return false;
			}

			var exists = false;
			var len = currentUsers.length;

			for (var i = 0; i < len && !exists; ++i) {
				if (usr.UserId === currentUsers[i].UserId) {
					exists = true;
				}
			}

			return exists;
		}

		function addUsers(event) {
			var groupUsers = smbUserGroupDataStore.userGroup.Embedded.Users;
			var newUsers = smbUsersDataStore.users.filter(function (user) {

				for (var x = 0; x < groupUsers.length; x++) {
					if (groupUsers[x].UserId === user.UserId) {
						return false;
					}
				}
				return true;
			});

			$mdDialog.show({
				controller: 'smbUserSelectorController',
				controllerAs: 'vm',
				templateUrl: userSelectorTemplateUrl,
				targetEvent: event,
				clickOutsideToClose: true,
				locals: {
					users: newUsers,
					multiSelect: true
				}
			})
			.then(function (selectedUsers) {
				//new users
				for (var i = 0; i < selectedUsers.length; i++) {
					smbUserGroupDataStore.userGroup.Embedded.Users.push(selectedUsers[i]);
				}
			}, function () {
				//cancel
			});
		}

		function removeUser(user) {
			var userIndex = smbUserGroupDataStore.userGroup.Embedded.Users.indexOf(user);
			if (userIndex === -1) { return; }
			smbUserGroupDataStore.userGroup.Embedded.Users.splice(userIndex, 1);
		}

		function save() {
			pxProgressService.backdrop = true;
			isLoading();

			smbUserGroupDataStore.saveUserGroup(vm.systemName)
				.then(function (response) {
					vm.userGroup = response;
					$state.go('^');
					var message = vm.userGroupId ? gettextCatalog.getString('User group saved!') : gettextCatalog.getString('New user group created!');
					sbToastService.showSimple(message);
				})
				.catch(function (e) {
					vm.errorMessage = e.data.Message;
				})
				.finally(doneLoading);
		}

		function isLoading() {
			vm.loading = true;
			pxProgressService.visible = true;
		}

		function doneLoading() {
			vm.loading = false;
			pxProgressService.visible = false;
		}

	}
})();


//////////////////
// WEBPACK FOOTER
// ./app/components/userGroup/userGroup.js
// module id = 102
// module chunks = 1